 <div class="loading-wrapper " >
  <div class="top-bar">
    <!-- <button class="back-btn">←</button>
    <span>Refreshing Media Contents</span> -->
  </div>

  <div class="status-container" >
  <div class="status-box" *ngFor="let item of loadingItems" [ngClass]="{ 'spin-border': !item.loaded, 'loaded-border': item.loaded }">
    <div class="card-lable">

      <div class="label">{{ item.label }}</div>
      <div class="d-flex">
        <div class="status"
        [ngClass]="{ 'complete': item.loaded, 'downloading': !item.loaded }"
        >
        {{ item.loaded ? 'Completed' : 'Downloading...' }}
      </div>
    </div>
  </div>
</div>
</div>



  <div class="spinner"></div>
  <div class="bottom-bar">PLEASE WAIT...</div>
</div>